import { render, staticRenderFns } from "./Game4-15.vue?vue&type=template&id=00f0b4c1&scoped=true&"
import script from "./Game4-15.vue?vue&type=script&lang=js&"
export * from "./Game4-15.vue?vue&type=script&lang=js&"
import style0 from "./Game4-15.vue?vue&type=style&index=0&id=00f0b4c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f0b4c1",
  null
  
)

export default component.exports